const NAME_WORD = "[A-Za-zÁÉÍÓÚÜÑáéíóúüñ'-]+";
const nameRegex = new RegExp(`^${NAME_WORD}(?:\\s+${NAME_WORD})+$`);

// Requiere 2 o más palabras (nombre + al menos un apellido); cada palabra admite guiones
// y apóstrofes (ej. "Pérez-Gómez", "O'Higgins") ya que el SSO los recibe como parte del nombre.
export const nameValidator = (name: string): boolean => {
	return nameRegex.test(name.trim());
};

// El SSO solo acepta name/lastname por separado. Un split(' ') naive descarta todo lo que
// esté después de la segunda palabra (ej. "Juan Pablo Rodríguez" -> pierde "Rodríguez"),
// así que la primera palabra es el nombre y el resto (unido con espacios) es el apellido.
export const getNameAndLastNameFromFullName = (fullName: string): { name: string; lastname: string } => {
	if (!fullName) return { name: '', lastname: '' };
	const words = fullName.trim().split(/\s+/).filter(Boolean);
	if (words.length === 0) return { name: '', lastname: '' };

	const [name, ...rest] = words;
	const lastname = rest.join(' ');

	return { name, lastname };
};
